// extracted by css-extract-rspack-plugin
module.exports =  {"liveTvEntryWidget":"eKdR3","title":"nMcWm","sponserBy":"OIi92","tabContainer":"UDw3y","liveTvStream":"L4PjN","item":"sAu0r","simulator":"f7Bpf"};